// @flow

import aiduAt from 'locale/aidu-at';
import aiduCh from 'locale/aidu-ch';
import aiduDe from 'locale/aidu-de';
import reisegeierAt from 'locale/reisegeier-at';
import reisegeierCh from 'locale/reisegeier-ch';
import reisegeierDe from 'locale/reisegeier-de';
import reisenDe from 'locale/reisen-de';
import reisenFluegeDe from 'locale/reisen-fluege-de';

export default {
  'aidu-at': aiduAt,
  'aidu-ch': aiduCh,
  'aidu-de': aiduDe,
  'reisegeier-at': reisegeierAt,
  'reisegeier-ch': reisegeierCh,
  'reisegeier-de': reisegeierDe,
  'reisen-de': reisenDe,
  'reisen-fluege-de': reisenFluegeDe,
};
